const Input = ({ label, placeholder, ...rest }) => {
  return (
    <>
      <label className="form-label __form-label" htmlFor={rest.id || label}>
        {label}
        {rest.required && <span className="__form-label-required-field"> *</span>}
      </label>
      <input className="form-control __form-control" placeholder={placeholder} {...rest} />
    </>
  );
};

export default Input;
